(function (ws) {
    'use strict';
    ws.views.compPhoneWithCountryCode = ws.views.form.extend({

        /**
         * Initialize
         */
        initialize() {
            var _this = this;
            this.$el.find('select').select2({
                templateSelection: _this.formatSelection,
                dropdownAutoWidth: true
            });

        },

        /**
         * Formats the display of the selected value in a select2 dropdown. In this case, it causes the
         * selected option's value to display in the dropdown instead of its text.
         */
        formatSelection(val) {
            return val.id;
        }

    });
})(westcon);
